import { Container, FormCheck } from "react-bootstrap";
import UserGrid from "./UserGrid";
import { User } from "./interfaces/User";
import { currentUserIsAdmin } from "../../firebase";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks";
import { requestWithAuthorization } from "../../network/apiRequests";
import CometSpinner from "../CometSpinner";

import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function DashboardTable() {
  const token = useAppSelector((state) => state.auth.token);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState<User[] | null>(null);
  const [hideAppleRelayUsers, setHideAppleRelayUsers] = useState(true);

  const navigate = useNavigate();

  // function to fetch users from the backend
  const fetchUsers = async () => {
    setIsLoading(true);

    try {
      // First try to fetch users with license information (includes roles)
      let response = await requestWithAuthorization(
        `${process.env.REACT_APP_API_HOSTNAME}/admin/users/license`
      );

      if (response.status === 200) {
        const usersData = response.data;
        setUserData(usersData || []);
        console.log("First 10 users with license info:", usersData.slice(0, 10));
      } else {
        // Fallback to basic users endpoint if license endpoint fails
        response = await requestWithAuthorization(
          `${process.env.REACT_APP_API_HOSTNAME}/users`
        );

        if (response.status === 200) {
          const users = response.data;
          setUserData(users);
        } else {
          navigate("/404");
        }
      }
    } catch (error) {
      console.error(error);
      // Try fallback to basic users endpoint
      try {
        const response = await requestWithAuthorization(
          `${process.env.REACT_APP_API_HOSTNAME}/users`
        );
        if (response.status === 200) {
          const users = response.data;
          setUserData(users);
        } else {
          navigate("/404");
        }
      } catch (fallbackError) {
        console.error(fallbackError);
        navigate("/404");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    currentUserIsAdmin().then((result) => {
      if (result) {
        fetchUsers();
      } else {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user?.uid) {
          navigate("/recordings/" + user?.uid);
        } else {
          navigate("/404");
        }
      }
    });
    setIsLoading(false);
  }, [token, navigate]);

  const spinnerContainer = (
    <Container
      style={{
        backgroundColor: "#091014",
        minHeight: "100vh",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CometSpinner height={100} />
    </Container>
  );

  if (isLoading) {
    return spinnerContainer;
  }

  if (!userData) {
    return <h1>No Data to show</h1>;
  }

  // Apply Apple ID relay filter
  const filteredUsers = hideAppleRelayUsers
    ? userData.filter(user =>
        // only call endsWith when email is a string; treat missing/non-string emails as non-relay
        typeof user.email === "string"
          ? !user.email.endsWith("@privaterelay.appleid.com")
          : true
      )
    : userData;

  return (
    <>
      <div className="mb-4">
        <FormCheck
          type="switch"
          id="hide-apple-relay-users"
          label="Hide users with @privaterelay.appleid.com emails"
          checked={hideAppleRelayUsers}
          onChange={(e) => setHideAppleRelayUsers(e.target.checked)}
          className="text-white"
        />
      </div>
      <UserGrid users={filteredUsers} isLoading={isLoading} />
    </>
  );
}
